import { Logger } from '@hawtiosrc/core/logging'

export const pluginName = 'hawtio-rbac'
export const log = Logger.get(pluginName)
